import {Slide, toast} from 'react-toastify';

export const nwToast = (msg: string) => toast(msg, {transition: Slide});
